export const LS_DISCUSSION = `discussion`;
export const LS_STUDENT = `student`;
export const LS_EDUCATOR = `educator`;
export const LS_ORGANIZATION = `organization`;
